(async () => {

  if (!customElements.get('featured-collection-swiper')) {

    const { default: Swiper, Autoplay } = await import("swiper");

    Swiper.use([
    Autoplay
    ]);

    class FeaturedCollection extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-featured-collection]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          slidesPerView: 4,
          direction: 'horizontal',
          breakpoints: {
            320: {
              slidesPerView: 1
            },
            375: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 3
            },
            1024: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            };
          }
        }

        this.init();
      }

      init() {
        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
      }
    }

    window.FeaturedCollection = FeaturedCollection;

    customElements.define('featured-collection-swiper', FeaturedCollection);

  }

})();
